var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":_vm.viewBox}},[_c('path',{style:({ fill: _vm.color }),attrs:{"data-name":"合体 271","d":"M24048 24552a1 1 0 1 0-2 0v4h-4v-7h.012l4.994-3 4.986 3h.012v7l-4 .006z","transform":"translate(-24039 -24543.001)"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }